import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { TaskFrequencyPeriod, RecurrenceEndEnum, } from "generated/generated-models";
import dayjs from "dayjs";
import { ListItem, ListItemText, Typography } from "@mui/material";
/**Displays when a transaction starts and how often it will repeat in a list group */
const DueOnListItems = (props) => {
    const recurring = props.frequency?.toLowerCase() !==
        TaskFrequencyPeriod.Once.toLowerCase();
    // Hack because dates are actually strings
    const formatDate = (date) => dayjs(new Date(date)).format("D MMM YYYY");
    const repeatText = () => {
        if (props.frequency?.toLowerCase() ===
            TaskFrequencyPeriod.Weekly.toLowerCase()) {
            return "Repeats Weekly";
        }
        else if (props.frequency?.toLowerCase() ===
            TaskFrequencyPeriod.Fortnightly.toLowerCase()) {
            return "Repeats Fortnightly";
        }
        else if (props.frequency?.toLowerCase() ===
            TaskFrequencyPeriod.Monthly.toLowerCase()) {
            return "Repeats Monthly";
        }
        else {
            return "";
        }
    };
    const untilText = () => {
        if (props.recurrence.toLowerCase() ===
            RecurrenceEndEnum.Bydate.toLowerCase()) {
            return `Ends on ${formatDate(props.endDate)}`;
        }
        else if (props.recurrence.toLowerCase() ===
            RecurrenceEndEnum.Numberofocurrences.toLowerCase()) {
            return `Ends after ${props.repeats} payments`;
        }
        else if (props.recurrence.toLowerCase() ===
            RecurrenceEndEnum.Never.toLowerCase()) {
            return "Continues Forever";
        }
        else {
            return "";
        }
    };
    return (_jsxs(_Fragment, { children: [props.paymentDate != null && (_jsx(ListItem, { disablePadding: true, children: _jsx(ListItemText, { primary: _jsxs(Typography, { children: [_jsx("span", { className: "subtitle", children: "Payment Date: " }), formatDate(props.paymentDate)] }) }) })), recurring && (_jsx(ListItem, { disablePadding: true, children: _jsx(ListItemText, { primary: _jsxs(Typography, { children: [_jsx("span", { className: "subtitle", children: "Reoccuring: " }), repeatText()] }) }) })), recurring && (_jsx(ListItem, { disablePadding: true, children: _jsx(ListItemText, { primary: _jsxs(Typography, { children: [_jsx("span", { className: "subtitle" }), untilText()] }) }) }))] }));
};
export default DueOnListItems;
